import { render, staticRenderFns } from "./DosMediaU4.vue?vue&type=template&id=019c82d3&scoped=true&"
import script from "./DosMediaU4.vue?vue&type=script&lang=js&"
export * from "./DosMediaU4.vue?vue&type=script&lang=js&"
import style0 from "./DosMediaU4.vue?vue&type=style&index=0&id=019c82d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019c82d3",
  null
  
)

export default component.exports